module.exports = __webpack_public_path__ + "img/product_29.fc41b43.webp";